import formatPhoneForDisplay from '@/helpers/format-phone-for-display';



function phone(value) {
  return formatPhoneForDisplay(value);
}



export default phone;
